import {
  useLeadQuery,
  useAddLeadNoteMutation,
  useGetLeadStageHistoryQuery,
} from "@/app/leads/leads.api";
import {
  useCreateTagMutation,
  useLeadTasksQuery,
  useTagMarketingQuery,
} from "@/app/users/users.api";
import { InformationPanelUser } from "@/shared/components/organisms/InformationPanelUser";
import Table from "@/shared/components/organisms/Table";
import TableListTasks from "@/shared/components/organisms/TableListTasks";
import { TabsUser } from "@/shared/components/organisms/TabsUser";
import { toasts } from "@/shared/utils/toasts";
import React, { useState, useEffect, useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  useGetAllTasksQuery,
  useAddTagMutation,
  useDeleteLabelMutation,
  useUpdateLabelMutation,
} from "../TasksPage/api/taskApi";
import ReactQuill from "react-quill";
import { TablaEtapas } from "./TablaEtapas";
import { Select } from "@/shared/components/organisms/Select";
import { ButtonWhite } from "@/shared/components/atoms/ButtonWhite";
import ButtonAdd from "@/shared/components/atoms/ButtonAdd";
import { t } from "i18next";
import {
    useGetLeadTasksQuery,
  useStoreNotesMutation,
  useStoreTaskMutation,
  useStoreTicketMutation,
} from "@/app/users/loyalty.api";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { useFormik } from "formik";
import {
  initialValuesForm2,
  initialValuesNotes,
  validationNotesSchema,
  validationSchemaForm2,
} from "@/shared/schemas/loyaltyUser.schema";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { SelectAvatar } from "@/shared/components/organisms/SelectAvatar";
import { ListHistorial } from "@/shared/components/organisms/ListHistorial";
import TaskTabs from "./tabs/TaskTabs";
import NotesTabs from "./tabs/NotesTabs";

// Define the Tab type
type Tab = { id: number; name: string };

const optionsTask = [
  { id: 0, name: t("lead.views.list_task_progress") },
  { id: 1, name: t("lead.views.list_tasks_complete") },
  { id: 2, name: t("lead.views.list_tasks_past") },
];

const Leads = () => {
  const { id } = useParams<{ id?: string }>();

  const { data: stageHistoryData } = useGetLeadStageHistoryQuery({
    leadId: id,
  });

  // ID de la sucursal in url => ?branch_id=17
  const [searchParams] = useSearchParams();
  const branchId = searchParams.get("branch_id");
  const [value, setValue] = useState("");

  const [openDialogTask, setOpenDialogTask] = useState(false);
  const handleOpenDialogTask = () => setOpenDialogTask(!openDialogTask);

  const [titleDialogTask, setTitleDialogTask] = useState("");
  const [textButtonSubmitTask, setTextButtonSubmitTask] = useState("");
  const [formTask, setFormTask] = useState(0);

  const [storeTicket, storeTicketResult] = useStoreTicketMutation();
  const [storeTask, storeTaskResult] = useStoreTaskMutation();
  const [storeNotes, storeNotesResult] = useStoreNotesMutation();
  const [selectTask, setSelectTask] = useState(0);

  const { data: leadDataTask  , refetch: refetchLeadDataTask } = useGetLeadTasksQuery({ leadId: id });
  const [addNote, { isLoading: isLoadingNote }] = useAddLeadNoteMutation();

  const [leadTasks, setLeadTasks] = useState([]);
  const useLazyLeadTasks = useLeadTasksQuery({
    id,
  });
  const [listStaff, setListStaff] = useState([]);

  useEffect(() => {
    if (value.length > 0) {
      addNote({
        notes: value,
        leadId: id,
      });
    }
  }, [value]);

  console.log("sss====", leadDataTask);

  const { data, isLoading, isError } = useLeadQuery({ id: id });

  const [createTag, createTagResult] = useCreateTagMutation();
  const tagMarketingQuery = useTagMarketingQuery(
    { branchId },
    { skip: parseInt(branchId) <= 0 }
  );

  // Define tabs
  const tabs: Tab[] = [
    { id: 1, name: "Tareas" },
    { id: 2, name: "Notas" },
    { id: 3, name: "Registro etapa de negocio" },
  ];

  // Set initial selected tab based on URL id or default to first tab
  const [selectedTab, setSelectedTab] = useState(tabs[0].id);

  // Handle tab change
  const handleTabChange = (tab: Tab) => {
    setSelectedTab(tab);
  };

  // Simulated remaining user data
  const fakeDataUserRestante = {
    someField: "Some Value",
    anotherField: 123,
  };

  // Estados para etiquetas
  const [userTags, setUserTags] = useState([]);
  const [marketingTags, setMarketingTags] = useState([]);
  const [userTagsSave, setUserTagsSave] = useState([]);
  const [marketingTagsSave, setMarketingTagsSave] = useState([]);

  // Opciones de etiquetas de usuario (type 2)
  const optionsUserTags = useMemo(() => {
    return tagMarketingQuery.data
      ? tagMarketingQuery.data
          ?.filter((role: any) => role.type === 2)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            color: role.color || "#000000",
          }))
      : [];
  }, [tagMarketingQuery.data]);

  // Opciones de etiquetas de marketing (type 1)
  const optionsMarketingTags = useMemo(() => {
    return tagMarketingQuery.data
      ? tagMarketingQuery.data
          ?.filter((role: any) => role.type === 1)
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            color: role.color || "#000000",
          }))
      : [];
  }, [tagMarketingQuery.data]);

  // Efecto para inicializar etiquetas seleccionadas
  useEffect(() => {
    const tagMarketingIds = data?.tag_merketing?.split(",").map(Number) || [];
    const tagUserIds = data?.tag_users?.split(",").map(Number) || [];

    // Tags seleccionados de marketing (type 1)
    const selectedMarketing = optionsMarketingTags.filter((option) =>
      tagMarketingIds.includes(Number(option.id))
    );
    setMarketingTags(selectedMarketing);

    // Tags seleccionados de usuario (type 2)
    const selectedUsers = optionsUserTags.filter((option) =>
      tagUserIds.includes(Number(option.id))
    );
    setUserTags(selectedUsers);
  }, [data, optionsMarketingTags, optionsUserTags]);

  // Función para obtener etiquetas únicas
  function getUniqueTags(
    currentTagsString: string,
    savedTags: { id: number }[]
  ) {
    const currentIds = (currentTagsString || "")
      .split(",")
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    const savedIds = savedTags.map((tag) => tag.id);

    const currentSet = new Set(currentIds);
    const savedSet = new Set(savedIds);

    const areEqual =
      currentIds.length === savedIds.length &&
      currentIds.every((id) => savedSet.has(id));

    if (areEqual) return [];

    const missingInSaved = currentIds
      .filter((id) => !savedSet.has(id))
      .map((id) => ({ id }));

    const newInSaved = savedTags.filter((tag) => !currentSet.has(tag.id));

    return [...missingInSaved, ...newInSaved];
  }

  // Efecto para guardar etiquetas
  useEffect(() => {
    const saveTags = async () => {
      try {
        const filteredUserTags = getUniqueTags(data?.tag_users, userTagsSave);
        const filteredMarketingTags = getUniqueTags(
          data?.tag_merketing,
          marketingTagsSave
        );

        if (userTagsSave.length > 0) {
          await createTag({
            user_id: id,
            type: 2,
            selectedValues: filteredUserTags.map((opt) => opt.id),
          }).unwrap();
          setUserTagsSave([]); // Limpiar
        }

        if (marketingTagsSave.length > 0) {
          await createTag({
            user_id: id,
            type: 1,
            selectedValues: filteredMarketingTags.map((opt) => opt.id),
          }).unwrap();
          setMarketingTagsSave([]); // Limpiar
        }
      } catch (error) {
        console.error("Error al crear tags:", error);
      }
    };

    saveTags();
  }, [userTagsSave, marketingTagsSave, createTag, id, data]);

  // Efecto para manejar el resultado de la creación de etiquetas
  useEffect(() => {
    if (createTagResult.isSuccess) {
      toasts.success(
        "Cambio exitoso",
        "La etiqueta ha sido cambiada correctamente"
      );
    }

    if (createTagResult.isError) {
      toasts.danger(
        "Error al cambiar",
        "Ha ocurrido un error al cambiar la etiqueta"
      );
    }
  }, [createTagResult]);

  // Mock state setters
  const [methodsPay, setMethodsPay] = useState(false);
  const [onRevenueUsers, setOnRevenueUsers] = useState(false);
  const [open, setOpen] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [toggleStatus, setToggleStatus] = useState(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalResults: 0,
  });

  const handlePageChange = (page: number) => {
    setPagination({ ...pagination, currentPage: page });
  };

  // Mock functions
  const changeStateUser = ({ id, state }: { id: number; state: string }) => {
    console.log(`Changing state for lead ${id} to ${state}`);
  };

  const handleRedirect = (leadId: number) => {
    console.log(`Redirecting to lead ${leadId}`);
  };

  const etapasEjemplo = [
    { id: 1, etapa: "Inicio", fecha: "2025-06-04" },
    { id: 2, etapa: "Crecimiento", fecha: "2025-12-01" },
  ];

  return (
    <div className="mx-auto max-w-full px-2 py-4 sm:px-2 lg:px-4">
      <div className="flex flex-1 px-10 gap-10">
        <div className="w-full flex flex-col ">
          <TabsUser
            tabs={tabs}
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
          />
          {/* render the user information */}
          <div className="pt-10">
            {/* tabs tarea */}
            {selectedTab === 1 && (
              <TaskTabs
                branchId={branchId}
                data={leadDataTask ?? []}
                loading={
                  useLazyLeadTasks.isLoading || useLazyLeadTasks.isFetching
                }
                id={id}
              />
            )}
            {/* tabs notas  */}
            {selectedTab === 2 && <NotesTabs note={data?.notes} leadId={id} />}

            {/* tabs historial  */}
            {selectedTab === 3 && (
              <div>
                <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-4  mb-5 md:mb-3">
                  Historial de asignaciones
                </h1>
                <ListHistorial history={stageHistoryData ?? []} />
              </div>
            )}
          </div>
        </div>
        <div className="md:col-start-10 md:row-end-1 md:col-span-3 w-[40%]">
          <InformationPanelUser
            noFirma={true}
            noPeopleTags={true}
            user={data || {}}
            noactive={true}
            userRestante={fakeDataUserRestante}
            optionsUserTags={optionsUserTags}
            selectedOptionsUserTags={userTags}
            setDeselectedOptionsUserTags={setUserTagsSave}
            setSelectedOptionsUserTags={setUserTags}
            setDeselectedOptionsMarketingTags={setMarketingTagsSave}
            userTagsSave={userTagsSave}
            marketingTagsSave={marketingTagsSave}
            optionMarketingTags={optionsMarketingTags}
            selectedOptionMarketingTags={marketingTags}
            setSelectedOptionMarketingTags={setMarketingTags}
            onMethodsPay={() => setMethodsPay(true)}
            ToggleStatus={toggleStatus}
            setToggleStatus={(lead: number, state: string) => {
              changeStateUser({ id: lead, state });
              setToggleStatus(!toggleStatus);
            }}
            handleEdit={() => setOpen(true)}
            handleFirma={() => console.log("Firma no implementada")}
            handleRestPass={() => setResetPassword(true)}
            handleWebApp={() => handleRedirect(Number(id))}
            handleDelet={() => setOpenDelete(true)}
            onRevenueUsers={() => setOnRevenueUsers(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default Leads;
